import { BlockReferenceArray } from '@/components/cms/types/block';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import { BlockHeaderContent } from '@/features/utils/BlockHeaderContent';
import { BlockWrapper } from '@/features/utils/BlockWrapper';

import { OpenPositionsList } from './OpenPositionsList';

export type OpenPositionsListStrapiItemProps = {
  slug: string;
  seo: {
    metaTitle: string;
  };
};
export interface OpenPositionsListStrapiProps {
  title: string;
  pages: BlockReferenceArray<OpenPositionsListStrapiItemProps>;
}

export function OpenPositionsListStrapi({
  block,
  ...rest
}: BlockComponentModel<OpenPositionsListStrapiProps>) {
  const { title, pages } = block;

  const formattedData =
    pages?.data?.map((page) => {
      return {
        slug: page.attributes.slug,
        metaTitle: page.attributes.seo.metaTitle.split('|')[0].trim(),
      };
    }) ?? [];

  return (
    <BlockWrapper {...rest}>
      <div
        data-tracker-section={SECTION_NAMES.OPEN_POSITIONS_LIST}
        className='w-full'
      >
        <BlockHeaderContent title={title}>
          <OpenPositionsList pages={formattedData} />
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
